import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import AdminCashierAPI from "../../../../apis/adminApi/AdminCashierAPI";
import Field from "../../../forms/Field";
import Select from "../../../forms/Select";
import MyButton from "../../../assets/MyButton";

const AdminAddCashAccount = () => {
    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(false);

    const [cashAccount, setCashAccount] = useState({
        name : "", t_amount : "", currency : ""
    });

    const [errors, setErrors] = useState({
        name : "", t_amount : "", currency : ""
    });

    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCashAccount({...cashAccount, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await AdminCashierAPI.storeCashAccount(cashAccount);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Le compte source ajouté avec succès");
            navigate("/admin/cashier/cashAccounts");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire !");
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter un compte source</h5>
                                <div className="row">
                                    <div className="col-10">
                                        <Field
                                            name="name"
                                            error={errors.name}
                                            value={cashAccount.name}
                                            onChange={handleChange}
                                            label="Nom du compte source"
                                            placeholder="KKS EXPRESS"
                                        />

                                        <Field
                                            name="t_amount"
                                            type="number"
                                            error={errors.t_amount}
                                            value={cashAccount.t_amount}
                                            onChange={handleChange}
                                            label="Montant"
                                            placeholder="000"
                                        />

                                        <Select name="currency" label="Devise"
                                                value={cashAccount.currency} error={errors.currency}
                                                onChange={handleChange}>
                                            <option value="">Choisir...</option>
                                            <option value="FC">CDF</option>
                                            <option value="USD">USD</option>
                                        </Select>
                                        {errors.currency && <div className="invalid-feedback mb-4">{errors.currency}</div>}
                                    </div>
                                </div>


                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/cashier/cashAccounts" className="btn btn-info mx-2">Revenir aux compte source</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAddCashAccount;
